import BaseException from './BaseException';

export default class TermsOfUseLoadingException extends BaseException {
}
